import React, { createContext, useContext, useState, useEffect } from "react";

interface GroupContextType {
  groupId: string | null;
  groupName: string | null; // versione "leggibile" del groupId
  setGroupId: (id: string | null) => void;
}

const GroupContext = createContext<GroupContextType>({
  groupId: null,
  groupName: null,
  setGroupId: () => {},
});

export const useGroup = () => useContext(GroupContext);

// Trasforma "grp_amicidelmonte" → "Amici del Monte"
function toReadableName(groupId: string): string {
  return groupId
    .replace(/^gr_/, "") // rimuove prefisso gr_ se presente
    .replace(/[-_]/g, " "); // sostituisce - e _ con spazio
}

export const GroupProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [groupId, setGroupIdState] = useState<string | null>(() => {
    return localStorage.getItem("aitf_groupId");
  });

  const groupName = groupId ? toReadableName(groupId) : null;

  const setGroupId = (id: string | null) => {
    setGroupIdState(id);
    if (id) {
      localStorage.setItem("aitf_groupId", id);
    } else {
      localStorage.removeItem("aitf_groupId");
    }
  };

  // Effetto: se ?community=... presente nella query string all'avvio, setta il groupId
  React.useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const community = params.get("community");
      if (community && community !== groupId) {
        setGroupId(community.toLowerCase());
      }
    } catch (e) {}
    // eslint-disable-next-line
  }, []);

  return (
    <GroupContext.Provider value={{ groupId, groupName, setGroupId }}>
      {children}
    </GroupContext.Provider>
  );
};
